import { jsx as e } from "react/jsx-runtime";
import { c as i } from "./index.CWkFp9WS.js";
import { memo as c, forwardRef as p } from "react";
const o = p(
  ({ as: r = "div", children: s, visibility: a = !0, className: m, ...t }, n) => a ? /* @__PURE__ */ e(
    r,
    {
      className: i("ODSContainer-basic--horizontal", m),
      ref: n,
      ...t,
      children: s
    }
  ) : null
);
o.displayName = "ODSRow";
const D = c(o);
export {
  D as O
};
//# sourceMappingURL=ODSRow.Du_e7gfN.js.map
